import React from 'react';
import { Nav, Navbar, /* Image, */ Container, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { /* Link, */ NavLink } from "react-router-dom";
import { logout } from '../actions/session';
import { logoutReq } from '../config/httpRoutes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { alertError } from '../config/toast';
// import { defImg } from '../config/globals';

class Header extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false
        };
    }

    logout = () => {
        this.setState({ loading: true });
        logoutReq({ id: this.props.userid })
            .then((res) => {
                this.props.logout();
            }).catch((err) => {
                alertError(err.response?.data?.msg || "Could not logout");
            }).finally(() => {
                this.setState({ loading: false });
            });
    }

    render() {
        const { links } = this.props;
        const { loading } = this.state;
        const { logout } = this;
        return (
            <Navbar bg="white" expand="md" fixed="top" style={ {marginBottom: '0px',}}>
                <Container style={{ maxWidth: '100%' }}>
                    <div style={{ flex: 9 }}></div>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="top-navbar-nav-login">
                        <Nav className="navbar-border ml-auto">
                            {links.map(({ name, link }, i) => (
                                <NavLink key={i} to={link} activeClassName="active" className="nav-link">
                                    {name}
                                </NavLink>
                            ))}
                        </Nav>
                        <Nav className="navbar-border">
                            <Button onClick={logout} variant="success" size="md">
                                {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Log Out'}
                            </Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        );
    }
}

const mapStateToProps = (state) => ({
    userid: state.session.userid
});

const mapDispatchToProps = (dispatch) => ({
    logout: () => { dispatch(logout()); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);